define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class ContractService
     */
    function ContractService($root, $q, $log, contractProvider, $indexedDB, $filter, commonService) {
        let self = this;

        /**
         * Return the map objet
         * @return {object}
         */
        self.getContractObject = function() {
            return {
                id: null,
                initiateBy: null,
                isSigned: false,
                dateSignature: null,
                isJdsInjected: false,
                isCancelled: false,
                dateCancellation: null,
                isSend: false,
                dateSend: null,
                contractComment: null,
                storeId: null,
                contractTypeId: null,
                manager: null,
                signBy: null,
                contractId: null
            };
        };

        /**
         * Get contracts
         * @param  {object} opts
         * @return {array}
         */
        self.getContracts = function getContracts(opts) {
            return contractProvider.getContracts(opts).then(function(contracts) {
                return contracts;
            });
        };

        /**
         * Get contracts for a store
         * @param  {int} id
         * @return {array}
         */
        self.getContractsByStore = function(id) {
            return contractProvider.getContractsByStore(id).then(function(contracts) {
                return contracts;
            });
        };

        /**
         * Create or update a contract
         * @param  {Object} data
         * @return {Promise}
         */
        self.createUpdate = function createUpdate(data) {
            return contractProvider.createUpdate(data).then(function(contractId) {
                return contractId;
            });
        };

        self.deleteContract = function(contract) {
            return contractProvider.deleteContract(contract.id).then(function(res) {
                return res.info;
            });
        };

        self.sendContract = function(contract) {
            return contractProvider.sendContract(contract.id, contract).then(function(res) {
                return res.info;
            });
        };

        self.cancelContract = function(contract) {
            return contractProvider.cancelContract(contract.id, contract).then(function(res) {
                return res.info;
            });
        };

        self.cancelReplaceContract = function(contract) {
            return contractProvider.cancelReplaceContract(contract.id, contract).then(function(res) {
                return res.info;
            });
        };

        self.signContract = function(contract) {
            return contractProvider.signContract(contract.id, contract).then(function(res) {
                return res.info;
            });
        };

        self.saveComment = function(contract) {
            return contractProvider.saveComment(contract.id, contract).then(function(res) {
                return res.info;
            });
        };

        self.setJdsInjected = function(contract, value) {
            return contractProvider.setJdsInjected(contract, value).then(function(res) {
                return res.info;
            });
        };

        return self;
    }

    ContractService.$inject = [
        '$rootScope',
        '$q',
        '$log',
        'contract',
        '$indexedDB',
        '$filter',
        'commonService',
        'localStorageService'
    ];

    angular.module('app.kya.contracts.contractService', []).factory('contractService', ContractService);
});
